import { getCurrentInstance, computed, reactive } from 'vue';
import { ModulePurchasePurpose } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCachePurchasePurposeComboConfig = () => {
  const { proxy } = getCurrentInstance();

  const store = useStore();

  const purchasePurposeCombo = computed(() => {
    const purchasePurposes = store.getters[`${ModulePurchasePurpose}/items`];
    return purchasePurposes.filter(x => !x.inactive);
  });

  // config columns combo
  const cachePurchasePurposeComboConfig = reactive({
    data: purchasePurposeCombo,
    columns: [
      {
        title: 'Mã nhóm',
        dataField: 'purchase_purpose_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên nhóm',
        dataField: 'purchase_purpose_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'purchase_purpose_code',
    valueField: 'purchase_purpose_id',
    queryMode: 'local',
    dropdownWidth: 600,
  });

  return {
    cachePurchasePurposeComboConfig,
  };
};
